export default __webpack_public_path__ + "static/media/mortgage-calculator.c0a70afb.png";